import { render } from "./EditarPerfil.vue?vue&type=template&id=70903065&scoped=true"
import script from "./EditarPerfil.vue?vue&type=script&lang=js"
export * from "./EditarPerfil.vue?vue&type=script&lang=js"

import "./EditarPerfil.vue?vue&type=style&index=0&id=70903065&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70903065"]])

export default __exports__